export default "__VITE_ASSET__BXRYbkLb__"